import { render } from "./P5.vue?vue&type=template&id=499d6f9d&scoped=true"
import script from "./P5.vue?vue&type=script&lang=js"
export * from "./P5.vue?vue&type=script&lang=js"

import "./P5.vue?vue&type=style&index=0&id=499d6f9d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-499d6f9d"]])

export default __exports__